<template>
    <div class="header">
      <div :class="{'show':imgState,'unshow':!imgState}" @click="imgState=!imgState">
         <img src="./../assets/kefu.jpg" alt="">
        <div class="desc">添加客服微信，随时问随时聊</div>
         <div class="nick">微信号：18922814318 </div>
        <div class="copyBtn" @click="copyNick(18922814318)">点击复制</div>
      </div>
     
         <div class="logo">
           
             <img src="./../assets/rrslogo.png" alt="">
             <i class="line"></i>
             <div class="item">
                 <p>中国检验认证集团战略合作伙伴</p>
                 <p>湖南大学国家大学科技园战略合作伙伴</p>
                 <p>深圳市钟表行业协会会员单位</p>

             </div>
                 <a href="tel:400-0083166">
                  <div class="tel">
                    <img src="./../assets/phone.png" alt="">
                  </div>
             </a>
         </div>

        
    </div>
</template>
<script>
const clickoutside = {
    // 初始化指令
    bind(el, binding, vnode) {
        function documentHandler(e) {
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
                return false;
            }
            // 判断指令中是否绑定了函数
            if (binding.expression) {
                // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                binding.value(e);
            }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
    },
    update() {},
    unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
    },
};
export default {
 
  data () {
    return {
      imgState:false,
      navState:false,
      rankVisible:false,
      groupState:false,
      data:''
    }
  },
  created () {
    
  },
   directives: {clickoutside},
  mounted () {
    this.data=this.getRandom(10,20)
  },
  updated () {
      
  },
  methods: {

    handleClose(e) {
            this.navState = false;
        },
    goTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    getRandom(min,max){
      return Math.floor(Math.random()*(max-min+1)+min)
    },
    copyNick(copyInfo){

       return new Promise((resolve, reject) => {
            let copyUrl = document.createElement("input"); //创建一个input框获取需要复制的文本内容
            copyUrl.value = copyInfo;
            let appDiv = document.getElementById('app');
            appDiv.appendChild(copyUrl);
            copyUrl.select();
            document.execCommand("Copy");
            copyUrl.remove()
            resolve(true);
            alert('复制成功！')
         })
    }

  },
  watch: {
   
  }
}
</script>
<style lang="less" scoped>
.header{
    height: 1.1rem;
    width: 100%;
    background-color: #f2db26;
    
    .show{
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.5);
      position: fixed;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      margin: auto;
      z-index: 9999;
      text-align: center;
      img{
        margin:3rem auto;
        margin-bottom: 0;
        width: 3.1rem;
      height: 3.1rem;
      
      }
      .desc{
        font-size: .24rem;
        color: #F1F1F1;
      }
      .nick{
        color: #333;
        margin: .1rem auto;
        font-size: .24rem;
        width: 3rem;
        line-height: .6rem;
         background: #f2db26;
        border:1px solid #f2db26;
      }
      .copyBtn{
        color: #333;
        font-size: .3rem;
        width: 3rem;
        line-height: .6rem;
      background: #f2db26;
      margin: .2rem auto;
      }
      
    }
    .unshow{
      display:none;
    }

    div.close{
      .menu-icon{
        span.item:nth-child(2){
          opacity: 0;
        }
        span.item:nth-child(1){
          transform: rotate(45deg);
          width: .4rem;
          top: 0.15rem;
          margin-top: 0;
          background: #fff;
        }
        span.item:nth-child(3){
          transform: rotate(-45deg);
          width: .4rem;
          top: 0.15rem;
          margin-top: 0;
          background: #fff;
        }
      }
    }

    .menu-icon{
        height: 1.466rem;
        width: .746rem;
        position: relative;
        .item{
          display: block;
          width: .4rem;
          height: .02rem;
          background: #f2db26;
          border-radius: .04rem;
          position: absolute;
          left: 90%;
          margin-left: -.28rem;
          transition: all .32s;
        }
        .item:nth-child(1){
          top: 50%;
          margin-top: .1rem;
        }
        .item:nth-child(2){
          top: 50%;
          margin-top: -.033rem;
        }
        .item:nth-child(3){
          bottom: 50%;
          margin-bottom: .15rem;
        }
      }


    .logo{
      box-sizing: border-box;
      height: 1rem;
        // width: 2rem;
        // height: auto;
        position: relative;
        display: flex;
        justify-content: space-around;
        img{
            width: 1.20rem;
            height: 1rem;
            margin: 0.05rem 0.2rem 0.2rem 0.2rem;
            float: left;
        }
        p.slogan{
          color: #000;
          font-size: .12rem;
          position: absolute;
          top: .5rem;
          
          left: .15rem;
        }
        .line{
            width: 1px;
            height: .4rem;
            display: inline-block;
            background: #333333;
            position: absolute;
            top:.3rem;
            left:1.6rem;
        }
        .item{
            width: 3.5rem;
            height: 0.9rem;
            float: left;
            padding-top: 0.15rem;
            margin-left: 0.25rem;
            p{
                font-size: .14rem;
                color: #333333;
                text-align: left;
                line-height: .25rem;
                margin:0;
                padding:0;
            }
        }
        .tel{
            margin-top: .1rem;
            width: 2.1rem;
            height: 0.8rem;
            position: relative;
            
         
            img{
              width: 1.66rem;
              height: 0.59rem;
            }
            
        }
    }
    .nav{
      font-size: .2rem;
        height: .4rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.2rem 0.4rem;
        background-color: #333;
        a{
            font-size: .2rem;
            color: #ffffff;
            text-decoration: none;
        }
         a.cur,li.cur a{
        color: #f2db26;
        font-size: .24rem;
      }
    }
    .menu-icon{
        width: .42rem;
            height: .4rem;
     img{
            width: .42rem;
            height: .4rem;
        }
    }
    ul{
        position: absolute;
        background: #333;
        z-index: 100;
        right: 0;
        top: 1.6rem;
        margin-top: 1px;
        width: 2rem;
      
        li{
              width: 2rem;
              line-height: .8rem;
              text-align: center;
               border-bottom: 1px solid #545454;
        a{
            display: block;
            font-size: .3rem;
            color: #fff;
            }
        }
    }
   .kefu{
        width: 100%;
        background-color: rgba(0,0,0,0.5);
        // background: url(./../images/gc/db.jpg) no-repeat;
        z-index: 999;
        position: fixed;
        bottom: 0;
        .wx{
          img{
            width: .5rem;
            height: .41rem;
          }
        }
  div{
    height: .8rem;
      a{
        text-decoration: none;
        display: inline-block;
    text-align: center;
    line-height: .8rem; 
    width: 33.3%;
    height: 100%;
    font-size: .26rem;
    color: #202020;
    background: #f2db26;
    // margin-top: .23rem;
    img{
      width: .37rem;
      height: .38rem;
      display: inline-block;
      vertical-align:middle;
    }
  }
  }

  a{
    box-sizing: border-box;
    border-right: 1px solid #ffffff;
  }
  a:last-child{
    border: none;
  }
  .kefur{
  position: relative;
  .num{
    width: .5rem;
    height: .5rem;
    font-size: .3rem;
    line-height: .5rem;
    border-radius: .5rem;
    background-color: #a50909;
    color: #F1F1F1;
    position: absolute;
    top: -.3rem;
    right: .2rem;
    
  }
}
}
}
</style>




// WEBPACK FOOTER //
// src/components/studentHeader.vue